import { getAnalyticsClient } from './helpers';

/**
 * The Google Adwords client factory function that sets up the `trackEvent`,
 * `trackConverion` and/or `trackUser` methods orchestrated by the upstream
 * analytics provider.
 *
 * @kind function
 * @name googleAdwords
 * @sig {k: v} -> (* -> undefined) -> Boolean -> {k: v}
 * @param {Object} config The analytics config that contains any extra metadata that needs to be sent with every conversion event posted to the google analytics service
 * @param {Function} log An optional logging method that unless it is undefined will always collect the event name and data.
 * @param {Boolean} noPublish Whether or not to send the event to the remote analytics service (or the global script attached to the same app).  This is mainly for debugging, never for production.
 * @returns {Object} An object containing the `trackEvent` and/or `trackConversion` implementations
 */
function google(config = {}, log, noPublish) {
  return {
    async trackConversion(eventName, eventData = {}) {
      const trackConversionGoogle = await getAnalyticsClient(
        'google_trackConversion',
        '//www.googleadservices.com/pagead/conversion_async.js'
      );

      const data = {
        google_conversion_id: config.id,
        google_conversion_color: config.color || 'ffffff',
        google_conversion_language: config.language || 'en',
        // disable the collection of remarketing data for users who do not wish to view personalized ads
        google_remarketing_only: false,
        ...config,
        ...eventData
      };

      if (trackConversionGoogle) {
        if (log) {
          log('[Analytics_GoogleAdwords_Conversion]', data);
        }

        if (!noPublish) {
          trackConversionGoogle(data);
        }
      }
    }
  };
}

export default google;
